'use client';

import { SurveyEntrance } from '@/features/player-survey/survey-entrance';

export const HeaderEvent = ({ className }: { className: string }) => {
	return (
		<div className={className}>
			<SurveyEntrance />
		</div>
	);
};